import React from "react";
import PropTypes from "prop-types";

import styles from "./NoResults.css";

export default function NoResults(props) {
  return (
    <div className={styles.root}>
      <div className={styles.emoji}>👻</div>
      {props.message}
    </div>
  );
}

NoResults.propTypes = {
  message: PropTypes.string.isRequired,
};
